<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="121"
    height="114"
    viewBox="0 0 121 114"
  >
    <defs>
      <pattern
        x="0"
        y="7"
        width="121"
        height="104"
        patternUnits="userSpaceOnUse"
        id="master_svg0_78_1359"
      >
        <image
          x="0"
          y="-0.7435897435897445"
          width="121"
          height="105.48717948717949"
          xlink:href="data:image/png;base64,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"
        />
      </pattern>
    </defs>
    <g>
      <g>
        <rect
          x="0"
          y="7"
          width="121"
          height="104"
          rx="0"
          fill="url(#master_svg0_78_1359)"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
